import { render, staticRenderFns } from "./variantKey.vue?vue&type=template&id=038fcea1&"
import script from "./variantKey.vue?vue&type=script&lang=js&"
export * from "./variantKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports